import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BlockScrollStrategy, Overlay} from '@angular/cdk/overlay';
import {MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {UnitSearchBarComponent} from 'app/layout/common/search/unit-search-bar/unit-search-bar.component';
import {SharedModule} from '../../../core/shared.module';
import {MatChipsModule} from '@angular/material/chips';
import {UnitSearchFormComponent} from './unit-search-form/unit-search-form.component';

@NgModule({
    declarations: [
        UnitSearchBarComponent,
        UnitSearchFormComponent
    ],
    imports: [
        RouterModule.forChild([]),
        MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        SharedModule,
        MatChipsModule
    ],
    exports: [
        UnitSearchBarComponent,
        UnitSearchFormComponent
    ],
    providers: [
        {
            provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => (): BlockScrollStrategy => overlay.scrollStrategies.block(),
            deps: [Overlay]
        }
    ]
})
export class SearchModule {
}
